export const b2bImpactStats = {
  medium: {
    tier1: {
      carbon: 0.3334,
      carbonAnnual: 4,
      trees: 2,
      footprints: 0.5,
    },
    tier2: {
      carbon: 0.6667,
      carbonAnnual: 8,
      trees: 4,
      footprints: 1,
    },
    tier3: {
      carbon: 1.3334,
      carbonAnnual: 16,
      trees: 8,
      footprints: 2,
    },
  },
  high: {
    tier1: {
      carbon: 0.7084,
      carbonAnnual: 8.5,
      trees: 3,
      footprints: 0.5,
    },
    tier2: {
      carbon: 1.4167,
      carbonAnnual: 17,
      trees: 6,
      footprints: 1,
    },
    tier3: {
      carbon: 2.8334,
      carbonAnnual: 34,
      trees: 12,
      footprints: 2,
    },
  },
};

export const b2cImpactStats = {
  medium: {
    personal: {
      carbon: 0.22,
      carbonAnnual: 2.64,
      trees: 2,
      footprints: 0.33,
    },
    booster: {
      carbon: 0.6667,
      carbonAnnual: 8,
      trees: 4,
      footprints: 1,
    },
    mega: {
      carbon: 1.3334,
      carbonAnnual: 16,
      trees: 8,
      footprints: 2,
    },
    children: {
      carbon: 0.11,
      carbonAnnual: 1.32,
      trees: 1,
      footprints: 0.165,
    },
    pets: {
      carbon: 0.05,
      carbonAnnual: 0.6,
      trees: 0,
      footprints: 0,
    },
  },
  high: {
    personal: {
      carbon: 0.3542,
      carbonAnnual: 4.25,
      trees: 3,
      footprints: 0.25,
    },
    booster: {
      carbon: 0.7084,
      carbonAnnual: 8.5,
      trees: 6,
      footprints: 0.5,
    },
    mega: {
      carbon: 1.4167,
      carbonAnnual: 17,
      trees: 12,
      footprints: 1,
    },
    children: {
      carbon: 0.1771,
      carbonAnnual: 2.125,
      trees: 2,
      footprints: 0.125,
    },
    pets: {
      carbon: 0.05,
      carbonAnnual: 0.6,
      trees: 0,
      footprints: 0,
    },
  },
};
